import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.module.css';
import { dashboardDes } from '../../language';

export const ArchetypesLabel = 'Archetypes: ';
export const CoreSkillsLabel = 'Core Skills: ';

export const RelatedContributionForGoal = ({
  archetypes,
  category,
  pageType
}) => {
  if (archetypes.length === 0 || ['Language', 'Technical'].includes(category)) {
    return null;
  }
  return (
    <div className={styles[pageType]}>
      <p className={styles.subTitle}>
        {dashboardDes.myPlanCardDes.contribution.notEmptyTitle}
      </p>
      <p>
        <span className={styles.title}>{ArchetypesLabel}</span>
        <span className={styles.archetypes}>{archetypes.join(', ')}</span>
      </p>
    </div>
  );
};
RelatedContributionForGoal.propTypes = {
  archetypes: PropTypes.array,
  category: PropTypes.string,
  pageType: PropTypes.string
};
